import script from "./FileReportView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileReportView.vue?vue&type=script&setup=true&lang=ts"

import "./FileReportView.vue?vue&type=style&index=0&id=3936d62a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3936d62a"]])

export default __exports__